import styled from 'styled-components';
import { FiltersContainer } from '@/layout/common-filter/styles/Filters.styles';
import {
  TriggerButton,
  TriggerText,
  TriggerArrow,
} from '@/components/inputs/styles/HierarchicalCheckboxDropdown.styles';

/**
 * Regression Filter Styles
 * Styles for the regression dashboard filter drawer
 */

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff;
  overflow: hidden;
`;

export const FilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 0.125rem solid rgba(104, 70, 209, 0.1);
  background: linear-gradient(to right, #faf9fe, #ffffff);
`;

export const FilterTitle = styled.h2`
  margin: 0;
  font-size: 0.875rem;
  font-weight: 700;
  color: #6846d1;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
`;

export const FilterBody = styled.div`
  flex: 1;
  min-height: 0;
  padding: 1.25rem;
  overflow-y: auto;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 0.5rem;
  }

  &::-webkit-scrollbar-track {
    background: #f3f4f6;
    border-radius: 0.25rem;
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(to bottom, #6846d1, #8b5cf6);
    border-radius: 0.25rem;

    &:hover {
      background: linear-gradient(to bottom, #5a3bb8, #7c4ddb);
    }
  }
`;

export const FilterItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4375rem;
`;

export const FilterLabel = styled.label`
  font-size: 0.6875rem;
  font-weight: 700;
  color: #6846d1;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  margin-bottom: 0.1875rem;
`;

export const FilterActions = styled.div`
  margin-top: 1rem;
  flex-shrink: 0;
  display: flex;
  gap: 0.625rem;
  padding: 1rem;
  border-top: 0.125rem solid rgba(104, 70, 209, 0.1);
  background: linear-gradient(to right, #faf9fe, #ffffff);
`;

export const ReleaseDashboardFilterContainer = styled(FiltersContainer)`
  min-height: 0;
  width: 100%;
  overflow: hidden;

  &,
  .filter-header,
  .filters-content,
  .filter-item,
  .filter-actions {
    box-sizing: border-box;
    max-width: 100%;
    min-width: 0;
  }

  .ant-space,
  .ant-space-item,
  .filter-item,
  ${TriggerButton} {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
  }

  .filter-header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-shrink: 0;

    h3 {
      flex: 1;
      min-width: 0;
      min-height: 24px;
      padding-right: 32px;
      gap: 0.5rem;
    }

    > button {
      position: absolute;
      right: 14px;
      top: 50%;
      transform: translateY(-50%);
      width: 24px;
      height: 24px;
      padding: 0;
      flex-shrink: 0;
      color: #ffffff;

      &:hover {
        color: #ffffff;
        background: rgba(255, 255, 255, 0.15);
      }
    }
  }

  .filters-content {
    min-height: 0;
  }

  ${TriggerButton} {
    min-height: 36px;
    padding: 6px 10px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 0.78rem;
    box-shadow: none;

    &:hover {
      border-color: #c4b5fd;
      box-shadow: none;
    }
  }

  ${TriggerText} {
    font-size: 0.78rem;
    line-height: 1.5;
  }

  ${TriggerArrow} {
    font-size: 0.7rem;
  }

  .filter-actions {
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
    flex-shrink: 0;
    margin-top: 0;
  }
`;
